<template>
  <BaseDialog
    centered
    contentClass="docKeywordsSettings"
    ref="dialog"
    :persistent="false"
    @closeModal="closeDialog"
    showHeader
  >
    <template slot="title">{{ $t('menu.admin-document-keywords') }}</template>
    <template slot="content">
      <slot name="content"> <DocumentKeywordsTable /> </slot>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import DocumentKeywordsTable from '@/components/page-document-keywords/DocumentKeywordsTable';

export default {
  name: 'DocKeywordsSettingsDialog',
  components: {
    BaseDialog,
    DocumentKeywordsTable,
  },
  props: {},
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
    },
  },
};
</script>

<style lang="scss">
.base-dialog__docKeywordsSettings {
  height: auto;
  min-height: 500px !important;
  max-height: 85% !important;
  width: 85%;
  position: relative;
  border-radius: $border-radius-root;
  top: auto;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    min-height: max-content;

    &::-webkit-scrollbar-track {
      background-color: $color-neutral-pale;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: $border-radius-large;
      background-color: $color-grey-pale;
    }
  }

  .base-dialog__actions {
    padding: 32px;
    background: transparent;
  }
}
</style>
